import Decimal from 'decimal.js';
import { isNotNil } from 'ramda';
import { DefaultValues } from 'react-hook-form';

import { intakeRequestDescriptionStepFormDataDefault } from '../IntakeRequestDescriptionStep/IntakeRequestDescriptionStep.schema';
import { Currency, SvbrgIntakeRequest } from '@/generated/gql/graphql';

import { FormSubmitData } from './components/IntakeRequestComplexStepForm';
import {
  IntakeRequestComplexStepFormData,
  intakeRequestComplexStepFormDataDefault,
} from './IntakeRequestComplexStep.schema';

export const toFormSchemaData = (
  request?: SvbrgIntakeRequest | null,
  summaryText?: string | null,
): DefaultValues<IntakeRequestComplexStepFormData> => {
  return {
    ...intakeRequestComplexStepFormDataDefault,
    ...request,
    commodityGroupId: request?.commodityGroupId ?? '',
    organizationId: request?.organizationId ?? '',
    deliveryLocationId: request?.deliveryLocationId,
    currency: request?.currency ?? Currency.EUR,
    budget: isNotNil(request?.budget) ? new Decimal(request?.budget).toNumber() : null,
    summary: {
      text: summaryText ?? '',
      language: intakeRequestDescriptionStepFormDataDefault.language,
    },
  };
};

export const toGraphqlFormat = (sessionId: string, formData: FormSubmitData) => {
  const { budget, lineItems, ...otherFields } = formData;

  const data = {
    chatSessionId: sessionId,
    ...otherFields,
    budget: isNotNil(budget) ? budget.toString() : null,
    lineItems: lineItems.map(({ expectedPricePerUnit, quantity, ...lineItem }, index) => ({
      ...lineItem,
      expectedPricePerUnit: expectedPricePerUnit?.toString() ?? '0',
      quantity: quantity.toString(),
      sequence: index + 1,
    })),
  };

  return {
    data,
  };
};
